import * as moment from 'moment';

export const preserveDateFromDateToMoment = (date: Date): moment.Moment => {
    if (!date) {
        return null;
    }

    const result = moment();

    result.set({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate()
    });

    return result;
};

export const preserveCurrentDateFromMoment = (date: moment.Moment): Date => {
    if (!date) {
        return null;
    }

    const result = new Date();

    result.setDate(date.date());
    result.setMonth(date.month());
    result.setFullYear(date.year());

    return result;
};

export const preserveDateFromStringToDate = (date: string): Date => {
    const result = new Date(date);

    // utc - to prvent from changing date (local - without utc) from string
    const momentDate = moment.utc(date);

    if (!date) {
        return;
    }

    result.setDate(momentDate.date());
    result.setMonth(momentDate.month());
    result.setFullYear(momentDate.year());

    return result;
};

export const preserveDateFromStringToMoment = (date: string): moment.Moment => {
    if (!date) {
        return null;
    }

    const result = moment();
    const dateFromString = moment.utc(date);

    result.set({
        year: dateFromString.year(),
        month: dateFromString.month(),
        date: dateFromString.date()
    });

    return result;
};

export const isValid = (input: moment.MomentInput): boolean => {
    const date = moment(input);
    return typeof input === 'string' ? !isNaN(Date.parse(input)) : date.isValid();
};

export const correctTimeZone = (date: Date): Date => {
    const minuteInMilliseconds = 60 * 1000;
    // const momentTime = moment();

    // convert to msec add local time zone offset
    // get UTC time in msec
    const utc = date.getTime() + (date.getTimezoneOffset() * minuteInMilliseconds);

    // create new Date object for different city using supplied offset
    // For some reason it works with adjustDates (query-string) function..
    return new Date(utc /*+ (momentTime.utcOffset() * minuteInMilliseconds)*/);
};

// https://www.bennadel.com/blog/3115-maintaining-javascript-date-values-during-deserialization-with-a-json-reviver.htm
// I am a JSON.parse() reviver that will parse serialized Date objects back into actual
// Date objects.
// --
// CAUTION: This gets called for every single value in the deserialized structure.
export const dateReviver = (key, value) => isSerializedDate(value) ? new Date(value) : value;

// I determine if the given value is a string that matches the serialized-date pattern.
const isSerializedDate = value => {
    // Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
    const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

    return isString(value) && datePattern.test(value);
}

// I determine if the given value is a String.
const isString = value => ({}.toString.call(value) === '[object String]');
